module.exports = __webpack_public_path__ + "static/media/rain_icon.497cf370.png";